import { all, fork } from "redux-saga/effects"

//public
import PublicacaoSaga from "./leads/publicacao/saga"
import ProcessoSaga from "./leads/processo/saga"
import LeadSaga from "./leads/lead/saga"
import ApoliceSaga from "./leads/apolice/saga"

import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import contactsSaga from "./contacts/saga";
import dashboardSaasSaga from "./dashboard-saas/saga";
import resetPasswordSaga from "./auth/resetpwd/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(contactsSaga),
    fork(PublicacaoSaga),
    fork(ProcessoSaga),
    fork(LeadSaga),
    fork(ApoliceSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),    
    fork(dashboardSaasSaga),
    fork(resetPasswordSaga)
  ])
}
